import {
  AnyAction,
  Dispatch,
  Middleware,
  configureStore,
} from "@reduxjs/toolkit";
import { logger } from "redux-logger";
import promise from "redux-promise-middleware";
import reducer from "./reducers/index";
// import { loadState } from "./browser-storage";

const middlewares = [promise as Middleware<any, any, Dispatch<AnyAction>>];
if (process.env.NODE_ENV === "development") {
  middlewares.push(logger as any);
}

// const persistedState = loadState();

const store = configureStore({
  reducer,
  devTools: process.env.NODE_ENV !== "production",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(...middlewares),
  // preloadedState: persistedState,
});
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
